import React from 'react';

const Test = props => {

    function click() {
        document.getElementById("one").onclick = function() {
            let more = document.getElementById("more")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
          
        }
        document.getElementById("two").onclick = function() {
            let more = document.getElementById("more2")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
        }
        document.getElementById("three").onclick = function() {
            let more = document.getElementById("more3")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
        }
        document.getElementById("four").onclick = function() {
            let more = document.getElementById("more4")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
        }
        document.getElementById("five").onclick = function() {
            let more = document.getElementById("more5")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
        }
        document.getElementById("six").onclick = function() {
            let more = document.getElementById("more6")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
        }
        document.getElementById("seven").onclick = function() {
            let more = document.getElementById("more7")
            more.classList.toggle("more");
            more.classList.toggle("notMore");
        }


    }
    click();


    return ( 
        <div> </div>
    )

}

export default Test;